// src/api/dinningApi.ts
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

export interface DinningAmenity {
  name: string;
  icon: string;
  image: string;
}

export interface DinningDetails {
  name: string;
  description: string;
  number: number;
  timing: string[];
  dress_code: string[];
  image: string;
}

export interface TrendingMenu {
  name: string;
  description: string;
  price: number;
  image?: string;
}

export interface DinningData {
  dinning_ameniti: DinningAmenity[];
  dinning_details: DinningDetails;
  trending_menu: TrendingMenu[];
  trending_menu_image: string;
}

export const getDinningData = async (): Promise<DinningData> => {
  try {
    const response = await axios.get(`${API_URL}/dinning`);
    return response.data;
  } catch (error) {
    console.error("Error fetching dining data:", error);
    throw error;
  }
};

export const createDinningData = async (dinningData: DinningData): Promise<DinningData> => {
  try {
    const response = await axios.post(`${API_URL}/dinning`, dinningData);
    return response.data;
  } catch (error) {
    console.error("Error creating dining data:", error);
    throw error;
  }
};

export const editDinningData = async (dinningData: DinningData): Promise<DinningData> => {
  try {
    const response = await axios.put(`${API_URL}/dinning`, dinningData);
    return response.data;
  } catch (error) {
    console.error("Error editing dining data:", error);
    throw error;
  }
};
